var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { fetchAllPackagesNames, fetchActivePackageServicesByEquipment, fetchPackageByEquipment } from '../../adapters/Subscriptions';
// Packages below have market services. Activation status check according
// to market service should be performed on them.
var packageHasMarketServiceList = [
    'Monitoring',
    'Analysis',
    'Control 10',
    'Monitoring_TachoRemote',
    'Analysis_TachoRemote',
    'Control_TachoRemote',
    'Control 1',
    'Control 5',
    'DataAccess 10',
    'DataAccess 5',
    'DataAccess 1',
    'Climate Control',
    'Driver Coaching',
    'Messaging',
    'Equipment Utilization',
    'Fleet Performance',
    'Driver Evaluation',
    'Monitoring Report Recipient',
    'Service Report Recipient',
    'Outbound', 'Site Optimization',
    'Scania Zone - Hybrid',
    'Control 10 - Engines',
    'Control 1 - Engines',
    'DataAccess 10 - Engines',
    'DataAccess 1 - Engines',
    'Autonomous Transport',
    'Control 5 - Engines',
    'DataAccess 5 - Engines',
    'Scania Zone - Speed Control'
];
var getInitialState = function () {
    var state = {
        packageNames: {},
        equipmentPackages: [],
        marketServicesByCustomer: {},
        isLoading: false,
        hasError: false,
        errorMessage: "",
        equipmentVehicleReference: ''
    };
    return state;
};
// Slice
var slice = createSlice({
    name: 'subscriptionInfo',
    initialState: getInitialState(),
    reducers: {
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        updateHasError: function (state, action) {
            state.hasError = action.payload !== '';
            state.errorMessage = action.payload;
        },
        setPackageNames: function (state, action) {
            state.packageNames = action.payload;
        },
        setEquipmentPackages: function (state, action) {
            state.equipmentPackages = action.payload;
        },
        setMarketServicesByCustomer: function (state, action) {
            state.marketServicesByCustomer = action.payload;
        },
        clearState: function (state) {
            state.packageNames = {};
            state.equipmentPackages = [];
            state.marketServicesByCustomer = {};
        },
        setEquipmentVehicleReference: function (state, action) {
            state.equipmentVehicleReference = action.payload;
        }
    },
});
export default slice.reducer;
// Actions
var _a = slice.actions, setIsLoading = _a.setIsLoading, updateHasError = _a.updateHasError, setPackageNames = _a.setPackageNames, setEquipmentPackages = _a.setEquipmentPackages, setMarketServicesByCustomer = _a.setMarketServicesByCustomer, clearState = _a.clearState, setEquipmentVehicleReference = _a.setEquipmentVehicleReference;
export var loadAllData = function (externalEquipmentReference) { return function (dispatch, state) { return __awaiter(void 0, void 0, void 0, function () {
    var packageNames_1, packagesResponse, equipmentPackagesResponse, equipmentPackages, marketServiceResponse, marketServicesByExternalCustomerReference, error_1, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                dispatch(setIsLoading(true));
                dispatch(setEquipmentVehicleReference(externalEquipmentReference));
                packageNames_1 = {};
                if (!!_.isEmpty(state.packageNames)) return [3 /*break*/, 1];
                packageNames_1 = state.packageNames;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, fetchAllPackagesNames()];
            case 2:
                packagesResponse = _a.sent();
                packagesResponse.data.forEach(function (packageObject) {
                    packageNames_1[packageObject.externalPackageReference] = packageObject.name;
                });
                _a.label = 3;
            case 3: return [4 /*yield*/, fetchPackageByEquipment(externalEquipmentReference, true)];
            case 4:
                equipmentPackagesResponse = _a.sent();
                equipmentPackages = processEquipmentPackages(equipmentPackagesResponse.data, packageNames_1);
                return [4 /*yield*/, fetchActivePackageServicesByEquipment(externalEquipmentReference)];
            case 5:
                marketServiceResponse = _a.sent();
                marketServicesByExternalCustomerReference = procesActivePackeServicesByEquipment(marketServiceResponse.data, packageNames_1);
                dispatch(setPackageNames(packageNames_1));
                dispatch(setEquipmentPackages(equipmentPackages));
                dispatch(setMarketServicesByCustomer(marketServicesByExternalCustomerReference));
                dispatch(setIsLoading(false));
                return [3 /*break*/, 7];
            case 6:
                error_1 = _a.sent();
                message = String(error_1);
                if (error_1 instanceof Error)
                    message = error_1.message;
                dispatch(clearState());
                dispatch(updateHasError(message));
                dispatch(setIsLoading(false));
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}); }; };
//#region Private Functions
var procesActivePackeServicesByEquipment = function (activeServicesWithCustomer, packageNames) {
    var marketServicesByExternalCustomerReference = _.groupBy(activeServicesWithCustomer, 'externalCustomerReference');
    _.forEach(_.keys(marketServicesByExternalCustomerReference), function (key) {
        _.forEach(marketServicesByExternalCustomerReference[key], function (e) {
            e['packageName'] = packageNames[e.externalPackageReference];
        });
    });
    return marketServicesByExternalCustomerReference;
};
var processEquipmentPackages = function (packagesWithCustomer, packageNames) {
    var packagesGroupByCustomerAsList = _.values(_.groupBy(packagesWithCustomer, 'externalCustomerReference'));
    var equipmentPackages = _.map(packagesGroupByCustomerAsList, function (packagesPerCustomer) {
        var result = {
            customer: {
                externalCustomerReference: packagesPerCustomer[0].externalCustomerReference,
                name: packagesPerCustomer[0].customerName,
                hasActivePackages: false
            },
            packages: _.map(packagesPerCustomer, function (p) {
                return {
                    name: packageNames[p.externalPackageReference],
                    timeStart: p.timeStart,
                    timeStop: p.timeStop,
                    isActive: (p.subscriptionStatusType === "Active" || p.subscriptionStatusType === "PendingDeactivation"),
                    hasMarketServices: _.includes(packageHasMarketServiceList, packageNames[p.externalPackageReference])
                };
            })
        };
        if (_.find(result.packages, { isActive: true })) {
            result.customer.hasActivePackages = true;
        }
        return result;
    });
    equipmentPackages = _.orderBy(equipmentPackages, ['customer.name'], ['asc']);
    _.forEach(equipmentPackages, function (customer) {
        customer.packages = _.orderBy(customer.packages, ['timeStop'], ['desc']);
    });
    return equipmentPackages;
};
//#endregion
